import React from 'react';

function RenderFieldOTPInput({
  inputRef,
  input,
  type,
  className,
  disabled,
  placeholder,
  maxLength,
  meta: { touched, error },
}) {
  // const [typeInput, setTypeInput] = useState(type);

  // return (
  //   <input
  //       {...input}
  //       ref={inputRef}
  //       type={type}
  //       disabled={disabled}
  //       className={className}
  //       placeholder={placeholder}
  //       maxLength={maxLength || "256"}
  //       onFocus={(e) => e.currentTarget.select()}
  //       style={{
  //       borderColor: `${touched && error ? '#FF0000' : '#727E91'}`,
  //     }}
  //     />
  // )

  return (
      <input
        {...input}
        ref={inputRef}
        type={type}
        disabled={disabled}
        className={className}
        placeholder={placeholder}
        maxLength={maxLength || "256"}
        onFocus={(e) => e.currentTarget.select()}
        style={{
        borderColor: `${touched && error ? '#FF0000' : '#727E91'}`
      }}
      />
  );
}

export default RenderFieldOTPInput;
